import { useCore } from '@/composables/core/index.js'
import { EVENTS, WEBVIEW_TYPES } from '@/lib/consts.js'
import { useEmitter } from '@/composables/emitter/index.js'

import {
  useVersionCheck,
  useLogger,
} from '@booksy-com/vue-tools'

const logger = useLogger('router.guard.reload-page')

export default function (to, from, next) {
  const emitter = useEmitter()
  const { store } = useCore()
  const { refreshRequired } = useVersionCheck()

  logger.debug(to.path)

  const isWebView = [WEBVIEW_TYPES.IOS, WEBVIEW_TYPES.ANDROID].includes(store.state.app.webView)

  if (refreshRequired.value) {
    isWebView
      ? emitter.emit(EVENTS.WEB_VIEW_CLEAR_CACHE)
      : window.location.reload()
  } else {
    next()
  }
}
